import { Component, input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ExpansionPanel } from '@shared/components/expansion-panel/expansion-panel.component';
import { LabelRequiredDirective } from '@shared/directives/label-required.directive';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';

@Component({
  selector: 'app-form-item-indice',
  imports: [ReactiveFormsModule, HlmInputImports, HlmFieldImports, ExpansionPanel, LabelRequiredDirective],
  templateUrl: './form-item-indice.component.html',
})
export class FormItemIndiceComponent {
  readonly idx = input.required<number>();
  readonly form = input.required<FormGroup>();

  get nom() {
    return this.form().get('nom') as FormControl<string>;
  }
}
